var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransfer = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 11.5848H3.3V15.1348L7.2925 11.5848H11.8775V13.6798L14.6575 10.8998L14.715 10.8423L11.8775 8.0048V10.0998H6.7275L4.7825 11.8273V10.0998H2.0625C1.745 10.0998 1.485 9.8398 1.485 9.5223V2.9248C1.485 2.6073 1.745 2.3473 2.0625 2.3473H13.94C14.2575 2.3473 14.5175 2.6073 14.5175 2.9248V4.9048C14.5175 5.2223 14.2575 5.4823 13.94 5.4823H6.765V3.3873L3.9825 6.1673L3.925 6.2248L6.7625 9.0623V6.9673H13.9375C15.075 6.9673 16 6.0423 16 4.9048V2.9248C16 1.7873 15.075 0.862305 13.9375 0.862305H2.0625C0.925 0.864805 0 1.7898 0 2.9248V9.5248C0 10.6598 0.925 11.5848 2.0625 11.5848Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Transfer.3dc3c867921634e90fd41d5005cfb422.svg";